export class DialogModelConfirmRetrieve {
    constructor(
      public confirmString: any
    ) {}
  }
  